import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Paper,
  Divider,
  Box,
  Button,
} from '@mui/material';

const ReceiptPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { plan, paymentId, billingInfo } = location.state || {};

  if (!plan || !paymentId) {
    return (
      <Container sx={{ py: 10 }}>
        <Typography align="center" variant="h6">
          Invalid receipt details.
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Paper elevation={4} sx={{ p: 4, borderRadius: 4 }}>
        <Typography variant="h5" gutterBottom align="center">
          🎉 Payment Successful!
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="subtitle1">
          <strong>Payment ID:</strong> {paymentId}
        </Typography>
        <Typography variant="subtitle1">
          <strong>Plan:</strong> {plan.name}
        </Typography>
        <Typography variant="subtitle1">
          <strong>Amount Paid:</strong> {plan.price}
        </Typography>
        <Typography variant="subtitle1">
          <strong>Duration:</strong> {plan.durationInDays}
        </Typography>
        {plan?.coupon && (<>
          <Typography variant="subtitle1">
            <strong>Coupon name:</strong> {plan.coupon.codename}
          </Typography>
          <Typography variant="subtitle1">
            <strong>Coupon code:</strong> {plan.coupon.code}
          </Typography>
          <Typography variant="subtitle1">
            <strong>Discount Amount:</strong> {plan.coupon.discountAmount}
          </Typography>
          <Typography variant="subtitle1">
            <strong>Duration:</strong> {plan.coupon.codename}
          </Typography>
        </>
        )}
        <Divider sx={{ my: 2 }} />
        <Typography variant="h6">Billing Info</Typography>
        <Divider sx={{ my: 2 }} />
        <Typography>Name: {billingInfo.masterCode}</Typography>
        <Typography>Email: {billingInfo.email}</Typography>
        <Typography>Phone: {billingInfo.mobile}</Typography>

        <Box mt={4} textAlign="center">
          <Button onClick={navigate("/")}
            variant="contained" sx={{
              bgcolor: '#1b1914',
              fontWeight: 'bold',
              borderRadius: 4
            }}>
            Back to Home
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default ReceiptPage;
